import React from "react";

import { Wrapper } from "app/NativeComponents/common";

import { Select } from "app/NativeComponents/snippets";

const IGNORE_VALUE = "IGNORE";

const getHeaderOptionTitle = (value, header_options) => {
  for (let i = 0; i < header_options.length; i++) {
    if (header_options[i].value === value) {
      return header_options[i].label;
    }
  }
  return "N/A";
};

const HeaderSelectOption = props => {
  if (props.header_item.header_mapped_value !== IGNORE_VALUE) {
    return (
      <Select
        item_ref={"select_header_map_" + props.header_index}
        items={props.header_options}
        title="Map to property field:"
        label="Select an option"
        value={props.header_item.header_mapped_value}
        text={getHeaderOptionTitle(
          props.header_item.header_mapped_value,
          props.header_options
        )}
        onSelect={value => {
          props.setHeaderOption(props.header_index, value);
        }}
      />
    );
  }

  return <Wrapper style={{ flex: 1 }} />;
};

export default React.memo(HeaderSelectOption);
